import {
  asEntityDefinition,
  asFacetDefinition,
  asField,
  asStruct,
  primitives,
  Translation
} from '@enisco/mcc-react-lib'

export interface LicenseEntity {
  uuid: string
  application: string
  fileContent: string
  usagedata: Record<string, unknown>
  parsed: {
    application: string
    customer: string
    description?: string
    expiration: string
    app_data: Record<string, unknown>
    translations?: Record<string, Translation>
  }
}

export const LicenseInfoDefinition = asEntityDefinition({
  primaryKey: 'uuid',
  nameField: {
    names: ['application']
  },
  api: {
    service: 'mcc-portal-api',
    path: '/internal/licenses'
  },
  facets: [
    asFacetDefinition({
      type: 'root',
      identifier: 'root',
      structs: [
        asStruct({
          fields: [
            asField({
              identifier: 'uuid',
              name: {en: 'ID'},
              struct: primitives.string
            }),
            asField({
              identifier: 'application',
              name: {en: 'Application'},
              struct: primitives.string
            }),
            asField({
              identifier: 'fileContent',
              struct: primitives.string
            }),
            asField({
              identifier: 'parsed',
              struct: asStruct({
                fields: [
                  asField({
                    identifier: 'application',
                    struct: primitives.string,
                    virtual: true
                  }),
                  asField({
                    identifier: 'customer',
                    struct: primitives.string,
                    virtual: true
                  }),
                  asField({
                    identifier: 'description',
                    struct: primitives.string,
                    virtual: true
                  }),
                  asField({
                    identifier: 'expiration',
                    struct: primitives.string,
                    virtual: true
                  })
                ]
              }),
              virtual: true
            })
          ]
        })
      ]
    })
  ]
})